@if (currentTags.length > 0) {
	<mat-chip-set [disabled]="false">
		@for (tag of currentTags; track tag.id) {
			@if (tag.name) {
				<mat-chip highlighted color="accent">
					{{ tag.name }}
				</mat-chip>
			}
		}
	</mat-chip-set>
}
